import Vue from 'vue'
import Router from 'vue-router'
import store from "../store"; 

// cts imports
import InboxView from '../views/InboxView.vue'
import CcedView from '../views/CcedView.vue'
import CompletedView from '../views/CompletedView.vue'
import SaveForLaterView from '../views/SaveForLaterView.vue'
import Dashboard from '../views/Dashboard'
import DashboardsView from '../views/DashboardsView.vue'
import AverageCompletionDashboard from '../components/cts-dashboards/AverageCompletionDashboard.vue';
import AverageDelayDashboard from '../components/cts-dashboards/AverageDelayDashboard.vue';
import CorrespondenceDashboard from '../components/cts-dashboards/CorrespondenceDashboard.vue';
import DraftView from '../views/DraftView.vue'
import SentView from '../views/SentView.vue'
import FollowUpView from '../views/FollowUpView.vue'
import ArchiveView from '../views/ArchiveView.vue'
import AdvancedSearch from '../views/AdvancedSearch.vue'
import AdfdSearch from '../views/AdfdSearch.vue'
import CreateDocumentView from '../views/CreateDocumentView.vue'
import UserDashboardsView from '../views/UserDashboards.vue'
import EditTemplateView from '../views/EditTemplateView.vue'
import ManageCorrespondenceView from '../views/ManageCorrespondenceView.vue'
import TrackingView from '../views/TrackingView.vue'
import AddressBookView from '../views/AddressBookView.vue'
import DeliveryNote from '../views/DeliveryNotesView.vue'
import Search from '../views/SearchView.vue'
import Reports from '../views/Reports/Reports.vue'
import Report from '../views/Reports/Report.vue'
import Delegations from '../views/Delegations.vue'
import DsReturn from '../views/DsReturn.vue'

import AdminMainView from '../views/admin/MainView.vue'
import OrganizationManagement from '../views/admin/OrganizationManagement.vue'
import ManageUsers from '../views/admin/ManageUsers.vue'
import ManageCorrespondences from '../views/admin/ManageCorrespondences.vue'
import SystemDelegation from '../views/admin/SystemDelegationView.vue'
import LookupsView from '../views/admin/LookupsView.vue'
import SystemParametersView from '../views//admin/SystemParametersView.vue'
import ActionsView from '../views/admin/ActionsView.vue'
import ManageRoles from '../views/admin/ManageRoles.vue'
import ManageDispatchEntities from '../views/admin/ManageDispatchEntities.vue'
import test from '../views/test.vue'
import ManageCounter from '@/views/admin/ManageCounter.vue'
import ManageRefernceFormat from '@/views/admin/ManageRefernceFormat.vue'
import ManageExternalEntities from '../views/admin/ManageExternalEntities.vue'
import ManageNotificationTemplates from '../views/admin/ManageNotificationTemplates.vue'
import ManageResources from '../views/admin/ManageResources.vue' 
import formioBuilder from '../views/admin/formio-test-builder.vue'
import formioRender from '../views/admin/formio-test-render.vue'
import ManageWorkflows from '../views/admin/ManageWorkflows.vue'
import ManageDynamicForms from '../views/admin/ManageDynamicForms.vue'
import ManageSystemLookups from '../views/admin/ManageSystemLookups.vue'
import ManageDocumentLooups from '../views/admin/ManageDocumentLooups.vue'
import ToDoLists from '../views/ToDoLists.vue' 
import ManageCommittees from '../views/admin/ManageCommittees.vue' 
import ManageMoveUser from '../views/admin/ManageMoveUser.vue'
import ManageCouncilAndMembers from '../views/admin/ManageCouncilAndMembers.vue'
import MOISettings from '../views/admin/MOISettings.vue';

import constants from '@/assets/js/constants';
import axios from 'axios';
Vue.use(Router)

var ctsRoutes = [
	{ path: '/', name: 'inbo', component: InboxView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/inbox', name: 'inbox', component: InboxView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/cced', name: 'cced', component: CcedView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/completed', name: 'completed', component: CompletedView, meta: {  customData: {permissionName: "Completed-Inbox"} } },
	{ path: '/hidden-inbox', name: 'hiddenInbox', component: SaveForLaterView, meta: {  customData: {permissionName: "HiddenInbox"} } },
	{ path: '/draft', name: 'draft', component: DraftView, meta: {  customData: {permissionName: "Draft"} } },
	{ path: '/sent', name: 'sent', component: SentView, meta: {  customData: {permissionName: "Sent"} } },
	{ path: '/followup', name: 'followup', component: FollowUpView, meta: {  customData: {permissionName: "FollowUp"} } },
	{ path: '/archive', name: 'archive', component: ArchiveView, meta: {  customData: {permissionName: "Archive"} } },
	{ path: '/advancedsearch', name: 'advancedsearch', component: AdvancedSearch, meta: {  customData: {permissionName: "AdvancedSearch"} } },

	{ path: '/adfdSearch', name: 'adfdSearch', component: AdfdSearch, meta: {  customData: {permissionName: "*"} } },
	{ path: '/tasks-list', name: 'ToDoLists', component: ToDoLists, meta: {  customData: {permissionName: "*"} } },
	{ path: '/create', name: 'createDocument', component: CreateDocumentView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/user-dashboard', name: 'userDashboard', component: UserDashboardsView, meta: {  customData: {permissionName: "!"} } },
	{ path: '/edit-template', name: 'editTemplate', component: EditTemplateView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/manage-correspondence', name: 'manageCorrespondence', component: ManageCorrespondenceView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/tracking', name: 'tracking', component: TrackingView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/delivery-note', name: 'deliveryNote', component: DeliveryNote, meta: {  customData: {permissionName: "DeliveryNote"} } },
	{ path: '/address-book', name: 'address-book', component: AddressBookView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/search', name: 'search', component: Search, meta: {  customData: {permissionName: "*"} } },
	{ path: '/dsReturn', name: 'dsReturn', component: DsReturn, meta: {  customData: {permissionName: "*"} } },
	{ 
		path: '/reports', name: 'reports', component: Reports, meta: {  customData: {permissionName: "Reports"} }, children: [
			{ path: 'report', name: 'report', component: Report, meta: {  customData: {permissionName: "Reports"} } }
		]
	},
	{ path: '/delegation', name: 'delegation', component: Delegations, meta: {  customData: {permissionName: "Delegation"} } },
	{
		path: '/admin', name: 'admin', component: AdminMainView, meta: {  customData: {permissionName: "Admin"} }, children: [
			{ path: 'organization', name: 'organization', component: OrganizationManagement, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-users', name: 'manageUsers', component: ManageUsers, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-correspondences', name: 'manageCorrespondences', component: ManageCorrespondences, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'system-delegation', name: 'systemDelegation', component: SystemDelegation, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-custom-lookups', name: 'manageCustomLookups', component: LookupsView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'system-parameters', name: 'systemParameters', component: SystemParametersView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'actions', name: 'actions', component: ActionsView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-roles', name: 'manageRoles', component: ManageRoles, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-dispatch-entities', name: 'manageDispatchEntities', component: ManageDispatchEntities, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-counter', name: 'manageCounter', component: ManageCounter, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-refernce-format', name: 'manageRefernceFormat', component: ManageRefernceFormat, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-external-entities', name: 'manageExternalEntities', component: ManageExternalEntities, meta: {  customData: {permissionName: "Admin"} } },
		    { path: 'manage-notification-templates', name: 'manageNotificationTemplates', component: ManageNotificationTemplates, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'formio-test-render', name: 'formioRender', component: formioRender, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'formio-test-builder', name: 'formioBuilder', component: formioBuilder, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-workflows', name: 'manageWorkflows', component: ManageWorkflows, meta: { customData: { permissionName: "Admin" } } },
			{ path: 'manage-resources', name: 'ManageResources', component: ManageResources, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-dynamic-forms', name: 'manageDynamicForms', component: ManageDynamicForms, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-system-lookups', name: 'manageSystemLookups', component: ManageSystemLookups, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-document-lookups/:pagenum', name: 'managedocumentlookups', component: ManageDocumentLooups, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-committees', name: 'ManageCommittees', component: ManageCommittees, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'move-user', name: 'ManageMoveUser', component: ManageMoveUser, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'Manage-Committees-And-Commitee-Members', name: 'ManageCouncilAndMembers', component: ManageCouncilAndMembers, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'MOISettings-view', name: 'MOISettingsView', component: MOISettings, meta: { customData: { permissionName: "Admin" } } }
		]
	},
	{
		path: '/dashboard', name: 'dashboards', component: DashboardsView, meta: {  customData: {permissionName: "Dashboard"} }, children: [
			{ path: 'general', name: 'dashboard', component: Dashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'average-completion-dashboard', name: 'average-completion-dashboard', component: AverageCompletionDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'average-delay-dashboard', name: 'average-delay-dashboard', component: AverageDelayDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'correspondence-dashboard', name: 'correspondence-dashboard', component: CorrespondenceDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
		]
	},
	{ path: '/test', name: 'test', component: test, meta: {  customData: {permissionName: "*"} } }
]

const router = new Router({ mode: 'history', base: process.env.BASE_URL, routes: [] })
ctsRoutes.forEach(route => router.addRoute(route))

router.beforeEach(async (to, from, next) => {
	if(constants.userActions.menu == undefined){
		constants.isPermissionsLoaded = false
		await axios.get(constants.baseApiUrl + 'User/GetUserActions?applicationId=' + window.defaultApplicationId)
		.then(res =>
		{
			res.data.menu.forEach(x=> {
				x.menuItems = JSON.parse(x.settings);
			});
			constants.userActions = res.data;
			constants.isFullAdmin = res.data.isFullAdmin;
			constants.isCompanyAdmin = res.data.isCompanyAdmin;
			constants.isManager = res.data.isManager;
			constants.isSecretary = res.data.isSecretary;
			constants.roleName = res.data.roleName;
			constants.isPermissionsLoaded = true
		})
		.catch(err => console.warn(err))
	}

	var hasAccess = 
		to.meta.customData &&
		to.meta.customData.permissionName &&
	(
		to.meta.customData.permissionName == "*" ||
		(
			constants.userActions.menu.some(f => f.name.toLowerCase() == to.meta.customData.permissionName.toLowerCase())
		)
	);
	
	if (!hasAccess) 
	{
	  	document.getElementById("logout").click();
		//next();
	}
	else
	{
		next();
	}
})

export default router